module.exports = {
      id: "login-usage",
      viewBox: "0 0 14.742 20.333",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#login",
      toString: function () {
        return this.url;
      }
    }